export default __webpack_public_path__ + "static/media/icon-upload.5ed67342.svg";